// Two-line labels for the category buttons in the header (small line on top, main word below).
export default {
  rail: {
    categories: {
      all: { top: "Todos los", bottom: "Paseos" },
      escunas: { top: "Paseos en", bottom: "Barco" },
      privadas: { top: "Lanchas y Barcos", bottom: "Privados" },
      compartilhadas: { top: "Lanchas", bottom: "Compartidas" },
      jeep: { top: "Paseos en", bottom: "Jeep" },
      bolivia: { top: "Expedición", bottom: "Bolivia" },
    },
  },
};
